// @flow

import { Schema, arrayOf } from 'normalizr';
import moment from 'moment';
import type { ThreadMessage } from '../types';

export const thread = new Schema('threads', {
  assignEntity: (output, key, value, input) => {
    // Update last message date to moment
    if (key === 'lastMessage' && value != null) {
      output.lastMessage = {
        ...value,
        date: moment(value.date, 'DD/MM/YYYY HH:mm'),
      };
    } else {
      output[key] = value;
    }
  },
});

export const message = new Schema('messages', {
  assignEntity: (output, key, value, input) => {
    // Update date to moment
    if (key === 'date') {
      const dateAsMoment = moment(value, 'DD/MM/YYYY HH:mm');
      output.date = dateAsMoment;
      // For grouping purposes
      output.day = dateAsMoment.format('DD/MM/YYYY');
    } else {
      output[key] = value;
    }
  },
});

export const enrichMessage = (message: ?ThreadMessage): ?ThreadMessage => {
  if (message != null) {
    return {
      ...message,
      date: moment(message.date, 'DD/MM/YYYY HH:mm'),
    };
  } else {
    return message;
  }
};

export const threads = arrayOf(thread);
export const messages = arrayOf(message);



// WEBPACK FOOTER //
// ./src/modules/messaging/api/schema.js